import React from 'react';
import styled from 'styled-components';

const SvgLogo = styled.svg`
  width: 124px;
  height: 32px;
  vertical-align: middle;
  color: #fff;
  fill: #fff;
  order: 1;
`;

const LogoSvg: React.FC = () => {
  return (
    <SvgLogo
      viewBox="0 0 124 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="14.6" fill="#ff1446" />
      <g fill="#fff">
        <path d="M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0s16 7.2 16 16-7.2 16-16 16m0-29.3C8.7 2.7 2.7 8.7 2.7 16s6 13.3 13.3 13.3c7.3 0 13.3-6 13.3-13.3S23.3 2.7 16 2.7" />
        <path d="M18.7 13.3V7.1h-5.4v6.2H7.1v5.4h6.2v6.2h5.4v-6.2h6.2v-5.4z" />
      </g>
      <path d="M40.4 10.9V7.3H47V21h2.7v3.7h-9.5V21h2.5V10.9zM65.3 13v6c0 3.8-2.9 6-6.5 6-3.5 0-6.5-2.2-6.5-6v-6c0-3.8 2.9-6 6.5-6s6.5 2.2 6.5 6m-4.2 5.9V13c0-1.4-1-2.1-2.3-2.1-1.3 0-2.3.7-2.3 2.1v5.9c0 1.4 1 2.1 2.3 2.1 1.3.1 2.3-.7 2.3-2.1M72 19.4c0 1.1.8 1.7 2 1.7s1.9-.9 1.9-2.1c0-2.5-2.5-2.4-4.4-2.3v-.6l2.3-4.8h-5v-4h11V8l-3.2 5.8c2.7.7 3.5 2.9 3.5 5.1 0 2.9-2.1 6-6.1 6-1.3 0-2.3-.3-3.1-.7-1.6-.9-2.8-2.7-2.8-4.9H72zM82.8 22.5c0-1.4 1.1-2.3 2.5-2.3 1.3 0 2.4.9 2.4 2.3s-1.1 2.3-2.4 2.3c-1.4 0-2.5-.9-2.5-2.3M104.7 7.3h-4.5v11.5c0 1.5-.9 2.3-2.5 2.3s-2.4-.8-2.5-2.3V7.3h-4.5v11.4c0 4.7 3.5 6.4 7 6.3 3.5 0 7-1.6 7-6.3V7.3" />
      <path d="M116.1 7.3h-2.3c-2.6 5.6-5.2 11.2-7.9 16.9v.4h4.7c.3-.7.7-1.4 1-2.1h6.6c.3.7.7 1.4 1 2.1h4.7v-.4c-2.6-5.7-5.2-11.3-7.8-16.9m-1.2 11.5H113.2c.6-1.4 1.1-2.7 1.8-4.1 0 0 0-.1.1-.2.6 1.4 1.3 3 1.9 4.3h-2.1" />
      <path d="M104.6 7.3h-4.5v11.4c0 1.5-.9 2.3-2.4 2.3-1.6 0-2.4-.8-2.4-2.3V7.3h-4.5v11.3c0 4.7 3.5 6.3 7 6.3s6.9-1.6 7-6.3c-.1-.1-.2-11.3-.2-11.3" />
    </SvgLogo>
  );
};

export default LogoSvg;
